<template>
  <div class="opus_content content_content">
    <div v-wechat-title="$tm(`index2024.${pathInfo.type}.title`)" />
    <GcSkeleton :is-show="loading" />
    <GcGuide :down-show="guideShow" @showDwon="getGuideStatus" />
    <ShareInfo :share-info="shareData" />
    <Banner :type="pathInfo.type" />

    <div class="index_content_w" :class="$route.query.type + '_content'">
      <p class="index_rule">{{ $tm(`index2024.${pathInfo.type}.tip`) }}</p>
      <ul class="opus_list">
        <li v-for="item in listData" :key="item.leader_id" class="list_item">
          <div class="item_left" @click="goPath('newsview', item)">
            <div :style="{'backgroundImage':'url('+ item.img1 +')'}" class="opus_pic rds4">
              <div :class="'ranking ranking'+item.sort"><span class="ft_bm">TOP</span> <i class="ft_bm">{{ addZero(item.sort) }}</i></div>
            </div>
            <div class="left_text">
              <div class="text_top">
                <h3 class="text_overflow2 font_bold">{{ item.title }}</h3>
                <div class="text_num">
                  <!-- <span class="opus_tag">{{ item.cuisine }}</span> -->
                  <div class="flex">
                    <div class="hot_black hot_none ft_bm">{{ item.num2 }}</div>
                    <span v-if="item.liked" class="followBtn rds48 followBtnEnd" @click.stop="like(item, 'likeDelTo2024', 0)">{{ $tm(`index2024.savedText`) }}</span>
                    <span v-else class="followBtn rds48" @click.stop="like(item, 'likeAddTo2024', 1)">{{ $tm(`index2024.saveText`) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <SideMenu :type="pathInfo.type" />
    <Footer />
  </div>
</template>

<script>
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import utils, { addZero } from '@/utils/utils'
import { superLink, checkloginCallback, platformType } from '@/utils/index'

import { Toast } from 'vant'
import Banner from '../components/banner'
import Footer from '../components/footer'
import SideMenu from '../components/sideMenu'
import ShareInfo from '@/components/shareInfo'
import GcGuide from '@/components/gc-guide'
import GcSkeleton from '@/components/gc-skeleton'

let timeout1 = null
export default {
  name: 'Opus',
  components: {
    Banner,
    Footer,
    SideMenu,
    ShareInfo,
    GcGuide,
    GcSkeleton
  },
  data() {
    return {
      loading: true, // 接口loading效果
      guideShow: false, // 微信点击的引导提示框
      pathInfo: {}, // 页面路径传参
      listData: [], // 列表数据
      shareData: { // 分享数据
        share_title: '',
        share_desc: '',
        share_link: '',
        share_img: ''
      }
    }
  },
  created() {
    const { query } = this.$route
    this.pathInfo = query

    this.getListData()

    this.shareData = {
      share_title: this.$tm(`index2024.${query.type}`).share_title,
      share_desc: this.$tm(`index2024.${query.type}`).share_des,
      share_link: location.href,
      share_img: 'https://static.mingchu.co/webapp/index2024/share/content.png'
    }

    if (utils.getQueryVariable('token')) {
      this.shareData.share_title = '2024 不容错过的精彩资讯内容。' 
      this.shareData.share_img = 'https://static.mingchu.co/webapp/index2024/minishare/content.png' 
    }
  },
  mounted() {
    const self = this
    window.scroll(0, 0)
    // 监听微信内点击弹起引导提示框
    window.mitt.on('guideShow', ($info) => {
      this.guideShow = $info
    })

    /* eslint-disable */
    sensors.track('MCINDEX2024_visit', {
      MCINDEX_title: self.pathInfo.type,
      from: '2024指数_最受关注的内容页面访问量',
      PlatformType: platformType()
    })
  },
  destroyed() {
    window.mitt.off('guideShow') // 销毁
    clearTimeout(timeout1)
  },
  methods: {
    addZero,
    // 获取列表数据
    getListData() {
      const self = this
      ajaxHttp.$get(
        '/api/ranking2024/detail', 
        { ...self.pathInfo, leader_type: self.pathInfo.type }
      ).then(res => {
        if (res.code == 1) {
          this.listData = res.data?.leaders ?? []
        }
        this.$nextTick(() => {
          self.loading = false
        })
      })
    },
    // 收藏
    like(item, type, changeStauts) {
      // 检查app是否登录，然后执行回调函数
      checkloginCallback(
        async function() {
          Toast.loading({ message: 'Loading...', forbidClick: true })
          const res = await ajaxHttp[type]({
            id: item.leader_id,
            type: '4',  // 1作品 | 4内容 | 6专题 | 7直播
            plant: '2'
          })
          if (res.code == 1) { 
            item.liked = (type === 'likeAddTo2024' ? true : false )
          }
          Toast.clear()
        }, this // 要传进去个this
      )
      /* eslint-disable */
      sensors.track('MCINDEX2024_collect_click', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受关注的内容页面收藏点击',
        PlatformType: platformType()
      })
    },
    goPath($des, _item) {
      sensors.track('MCINDEX2024_card_click', {
        MCINDEX_title: this.pathInfo.type,
        from: '2024指数_最受关注的内容页面卡片点击',
        card_name: _item.title,
        PlatformType: platformType(),
      })
      // JSON标准格式双引号，eslint默认单引号，冲突
      const data = `{
        "des": "${$des}", 
        "skuid": "${_item.leader_id}",
        "link": "${config.webapplink}/${$des}?id=${_item.leader_id}&referrer=index2024_content"
      }`
      return superLink(data)
    },
    getGuideStatus(val) { // 获取子组件的返回
      this.guideShow = false
    },
    getBulletChat($item) {
      console.log('父元素', $item)
    }
  }
}
</script>
<style lang="scss" scoped>
@charset "utf-8";
@function r($px){  // 适配 375px宽
	@return $px*(1/37.5)*1rem;
}
.tab_prize{
  margin: r(12) r(16) 0;
}

.hot_none.ft_bm {
  font-weight: 500;
}
</style>
